
export const GET_USER_DETAILS_FOR_ADMIN_REQUEST = "GET_USER_DETAILS_FOR_ADMIN_REQUEST";
export const GET_USER_DETAILS_FOR_ADMIN_SUCCESS = "GET_USER_DETAILS_FOR_ADMIN_SUCCESS";
export const GET_USER_DETAILS_FOR_ADMIN_FAILURE = "GET_USER_DETAILS_FOR_ADMIN_FAILURE";

